import React from "react";
import { Carousel } from "react-bootstrap";
import CardBannerCliente from "../CardBannerCliente/CardBannerCliente";
import CardBannerClienteClipp from "../CardBannerCliente/CardBannerClienteClipp";
import './BannerCardCliente.scss'

const BannerCardCliente = ({ datos }) => {
    return (
        <Carousel indicators={false}>
            {
                datos.map(dato =>
                    dato.tarifa !== 'Clipp' ?
                        <Carousel.Item className="center-children" key={`Carrusel-${dato.id}`} >
                            <CardBannerCliente data={dato} key={`CardCliente-${dato.id}`}></CardBannerCliente>
                        </Carousel.Item>
                        :
                        <Carousel.Item className="center-children" key={`Carrusel-${dato.id}`} >
                            <CardBannerClienteClipp data={dato} key={`CardCliente-${dato.id}`}></CardBannerClienteClipp>
                        </Carousel.Item>
                )
            }

        </Carousel>
    );
}
export default BannerCardCliente